import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';

interface ProducedProductState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: ProducedProductState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_PRODUCED_PRODUCTS_LIST';
export const PRODUCED_PRODUCTS = 'GET_PRODUCED_PRODUCTS';
export const PRODUCED_PRODUCTS_INGREDIENTS = 'GET_PRODUCED_PRODUCTS_INGREDIENTS';

export const actions: ActionTree<ProducedProductState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "produced_products.id",
                "name": "produced_products.name",
                "copy_name": "produced_products_copy.name",
                "created_at": "produced_products.created_at",
                "archived_at": "produced_products.archived_at",
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["produced_products.name", {"$": `%${query.name}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:produced_products",
                    "from_as": "produced_products",
                    joins: [
                        {
                            join: 's:produced_products',
                            type: 'left',
                            as: 'produced_products_copy',
                            on: {
                              $eq: ['produced_products_copy.id', 'produced_products.copy_id']
                            }
                        }
                    ],
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            {$desc: ['produced_products.archived_at']},
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    copyDocument({ state }, {id}) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q(PRODUCED_PRODUCTS)
                    .raw('documents.get')
                    .action({
                        id
                    }),
                vm.$q(PRODUCED_PRODUCTS_INGREDIENTS)
                    .raw('documents.list')
                    .action({
                        columns: {
                            ingredient_id: 'produced_product_ingredients.ingredient_id',
                            value_time_1: 'produced_product_ingredients.value_time_1',
                            value_time_2: 'produced_product_ingredients.value_time_2',
                            value_time_3: 'produced_product_ingredients.value_time_3',
                            value_time_4: 'produced_product_ingredients.value_time_4',
                            value_time_5: 'produced_product_ingredients.value_time_5',
                            value_time_6: 'produced_product_ingredients.value_time_6',
                            value_time_7: 'produced_product_ingredients.value_time_7',
                        },
                        from: 's:produced_product_ingredients',
                        from_as: 'produced_product_ingredients',
                        where: {
                            $eq: ['produced_product_ingredients.produced_product_id', {$: id}]
                        }
                    }),
            ]).then((result: ServerResult) => {
                const product = result.getOperation(PRODUCED_PRODUCTS).getContent().document;
                const ingredients = result.getOperation(PRODUCED_PRODUCTS_INGREDIENTS).getContent().documents;

                product.copy_id = product.id;
                delete product.id;
                product.name = product.name + ' копия'

                const queries: any[] = [
                    vm.$q(PRODUCED_PRODUCTS)
                        .create('s:produced_products', product)
                        .withManyRelation('produced_product_ingredients', 'produced_product_id', (createRelated: any) => {
                            return ingredients.map((item: any) => createRelated(item));
                        })
                ]
                vm.$db(queries).then((result: ServerResult) => {
                    resolve(null);
                })
                .catch((error: any) => {
                    console.error('errror', error)
                    reject(error);
                });

            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

    saveTodoType({ commit, getters, dispatch }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_DOCUMENT').update(data.id, data) :
            vm.$q('SAVE_DOCUMENT').create('produced_products', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_DOCUMENT');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

};

export const mutations: MutationTree<ProducedProductState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_produced_products';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
